// Translation object for GUI elements and context
interface Translation {
  ar: string;
  en: string;
}

interface TranslationObject {
  product: {
    name: Translation;
    logo: Translation;
    defaultUiLanguage: string;
    isDark: boolean;
  };
  nav: {
    features: Translation;
    pricing: Translation;
    howItWorks: Translation;
    dashboard: Translation;
  };
  hero: {
    badge: Translation;
    title1: Translation;
    title2: Translation;
    subtitle1: Translation;
    subtitle2: Translation;
    startTrial: Translation;
    watchDemo: Translation;
    stat1Label: Translation;
    stat1Value: Translation;
    stat2Label: Translation;
    stat2Value: Translation;
    stat3Label: Translation;
    stat3Value: Translation;
  };
  problem: {
    title: Translation;
    subtitle: Translation;
    issue1Title: Translation;
    issue1Desc: Translation;
    issue2Title: Translation;
    issue2Desc: Translation;
    issue3Title: Translation;
    issue3Desc: Translation;
  };
  solution: {
    titlePart1: Translation;
    titlePart2: Translation;
    subtitle: Translation;
    step1Title: Translation;
    step1Desc: Translation;
    step2Title: Translation;
    step2Desc: Translation;
    step3Title: Translation;
    step3Desc: Translation;
  };
  features: {
    title: Translation;
    subtitle: Translation;
    feature1Title: Translation;
    feature1Desc: Translation;
    feature2Title: Translation;
    feature2Desc: Translation;
    feature3Title: Translation;
    feature3Desc: Translation;
    feature4Title: Translation;
    feature4Desc: Translation;
    feature5Title: Translation;
    feature5Desc: Translation;
    feature6Title: Translation;
    feature6Desc: Translation;
  };
  pricing: {
    title: Translation;
    subtitle: Translation;
    starter: Translation;
    starterDesc: Translation;
    professional: Translation;
    professionalDesc: Translation;
    business: Translation;
    businessDesc: Translation;
    mostPopular: Translation;
    perMonth: Translation;
    queries: Translation;
    storage: Translation;
    users: Translation;
    unlimitedUsers: Translation;
    webWidget: Translation;
    whatsappWeb: Translation;
    advancedAnalytics: Translation;
    prioritySupport: Translation;
    startTrial: Translation;
    setupFee: Translation;
    waived: Translation;
    trialInfo: Translation;
  };
  cta: {
    title: Translation;
    subtitle: Translation;
    button: Translation;
    info: Translation;
  };
  footer: {
    tagline: Translation;
    copyright: Translation;
    copyrightYear: Translation;
  };
}

const T: TranslationObject = {
  product: {
    // name: { ar: 'لبيب', en: 'LaBeeB' },
    name: { ar: 'SmartDocs AI', en: 'SmartDocs AI' },
    logo: {ar: 'شعار SmartDocs AI' ,en:'SmartDocs AI Logo'},
    defaultUiLanguage: 'en',
    isDark: false,
  },
  nav: {
    features: { ar: 'المميزات', en: 'Features' },
    pricing: { ar: 'الأسعار', en: 'Pricing' },
    howItWorks: { ar: 'كيف يعمل', en: 'How It Works' },
    dashboard: { ar: 'لوحة التحكم', en: 'Admin Dashboard' }
  },
  hero: {
    badge: { ar: 'إبدأ العمل في 24 ساعة | عربي + إنجليزي', en: 'Deploy in 24 Hours | Arabic + English' },
    title1: { ar: 'امنح فريقك', en: 'Give Your Team' },
    title2: { ar: 'إجابات فورية', en: 'Instant Answers' },
    subtitle1: { ar: 'مساعد المعرفة الذكي الوحيد بالعربية أولاً والمصمم للمؤسسات الصغيرة والمتوسطة.', en: 'The only Arabic-first AI knowledge assistant built for SMEs.' },
    subtitle2: { ar: 'حوّل طريقة وصول موظفيك إلى معلومات الشركة.', en: 'Transform how your employees access company information.' },
    startTrial: { ar: 'ابدأ تجربة مجانية لمدة 14 يومًا', en: 'Start 14-Day Free Trial' },
    watchDemo: { ar: 'شاهد عرض توضيحي لمدة دقيقتين', en: 'Watch 2-Min Demo' },
    stat1Label: { ar: 'توفير في التكاليف', en: 'Cost Savings' },
    stat1Value: { ar: '%85', en: '85%' },
    stat2Label: { ar: 'وقت إطلاق الخدمة', en: 'Deployment' },
    stat2Value: { ar: '24 ساعة', en: '24hrs' },
    stat3Label: { ar: 'وقت الاستجابة', en: 'Response Time' },
    stat3Value: { ar: '3 ثواني', en: '3sec' },
  },
  problem: {
    title: { ar: 'المؤسسات تهدر 40+ ساعة شهرياً', en: 'SMEs Waste 40+ Hours Monthly' },
    subtitle: { ar: 'على أسئلة الموظفين المتكررة. هل هذا مألوف؟', en: 'On repeated employee questions. Sound familiar?' },
    issue1Title: { ar: 'الموظفون يسألون بشكل متكرر', en: 'Employees Ask Repeatedly' },
    issue1Desc: { ar: 'ما هي سياسة الإجازات؟ كيف أقدم المصروفات؟ نفس الأسئلة، كل يوم.', en: 'What is the vacation policy? How do I submit expenses? Same questions, every day.' },
    issue2Title: { ar: 'المعلومات مبعثرة', en: 'Information Scattered' },
    issue2Desc: { ar: 'رسائل البريد الإلكتروني، الملفات المشتركة، مجموعات واتساب. إيجاد أي شيء يستغرق وقتاً طويلاً.', en: 'Emails, shared drives, WhatsApp groups. Finding anything takes forever.' },
    issue3Title: { ar: 'وقت مهدر', en: 'Time Wasted' },
    issue3Desc: { ar: 'المديرون يقضون 10+ ساعات أسبوعياً في الإجابة. هذا 200+ دينار كويتي من الإنتاجية المفقودة.', en: 'Managers spend 10+ hours weekly answering. That is 200 KWD+ in lost productivity.' }
  },
  solution: {
    titlePart1: { ar: 'الحل مع ', en: 'The ' },
    titlePart2: { ar: '', en: ' Solution' },
    subtitle: { ar: 'إنطلق في 3 خطوات بسيطة. إبدأ العمل في 24 ساعة.', en: 'Deploy in 3 simple steps. Go live in 24 hours.' },
    step1Title: { ar: '1. الرفع', en: '1. Upload' },
    step1Desc: { ar: 'اسحب وأفلت مستنداتك: PDF، Word، Excel. دليل الموظف، كتالوجات المنتجات، السياسات. نعالج كل شيء في دقائق.', en: 'Drag and drop your documents: PDFs, Word, Excel. Employee handbooks, product catalogs, policies. We process everything in minutes.' },
    step2Title: { ar: '2. اسأل', en: '2. Ask' },
    step2Desc: { ar: 'الموظفون يسألون عبر واتساب، أداة الويب، أو الهاتف المحمول. بلغة طبيعية. عربي أو إنجليزي. لا حاجة للتدريب.', en: 'Employees ask via WhatsApp, web widget, or mobile. In natural language. Arabic or English. No training needed.' },
    step3Title: { ar: '3. الإجابة', en: '3. Answer' },
    step3Desc: { ar: 'احصل على إجابات فورية ودقيقة مع اقتباسات المصدر. توفر على مدار الساعة. لا بحث في الملفات. لا إزعاج للزملاء.', en: 'Get instant, accurate answers with source citations. 24/7 availability. No searching files. No bothering colleagues.' }
  },
  features: {
    title: { ar: 'مصمم للأعمال العربية', en: 'Built for Arabian Businesses' },
    subtitle: { ar: 'كل ما تحتاجه. لا شيء لا تحتاجه.', en: 'Everything you need. Nothing you do not.' },
    feature1Title: { ar: 'عربي-إنجليزي حقيقي', en: 'True Arabic-English' },
    feature1Desc: { ar: 'اسأل بالعربية، احصل على إجابات بالعربية. أو من الإنجليزية إلى الإنجليزية. دعم أصلي، وليس ترجمة غير دقيقة.', en: 'Ask in Arabic, get answers in Arabic. Or English to English. Native support, not clunky translations.' },
    feature2Title: { ar: 'تكامل واتساب', en: 'WhatsApp Integration' },
    feature2Desc: { ar: 'الموظفون يستخدمون واتساب بالفعل 50 مرة يومياً. لا تطبيق جديد للتعلم. فقط أرسل رسالة واحصل على الإجابات.', en: 'Employees already use WhatsApp 50 times daily. No new app to learn. Just text and get answers.' },
    feature3Title: { ar: 'أمان بمستوى البنوك', en: 'Bank-Level Security' },
    feature3Desc: { ar: 'بيانات مشفرة، خوادم محلية، اختيارك للمنطقة. خارطة طريق SOC 2. اتفاقيات عدم الإفصاح متاحة.', en: 'Encrypted data, domestic servers, your choice of region. SOC 2 roadmap. NDAs available.' },
    feature4Title: { ar: 'نشر في 24 ساعة', en: '24-Hour Deployment' },
    feature4Desc: { ar: 'ليس 6 أشهر مثل التطوير المخصص. ارفع المستندات اليوم، الموظفون يستخدمونها غداً.', en: 'Not 6 months like custom development. Upload documents today, employees using tomorrow.' },
    feature5Title: { ar: 'تحليلات ذكية', en: 'Smart Analytics' },
    feature5Desc: { ar: 'شاهد الأسئلة الأكثر طرحاً، حدد فجوات المعرفة، تتبع الاستخدام. اتخذ قرارات أفضل.', en: 'See most-asked questions, identify knowledge gaps, track usage. Make better decisions.' },
    feature6Title: { ar: 'إدارة بدون برمجة', en: 'No-Code Management' },
    feature6Desc: { ar: 'فريق الموارد البشرية أو الإدارة يديره. لا حاجة لفريق تقنية. لا حاجة للمطورين.', en: 'Your HR or admin team manages it. No IT team needed. No developers required.' }
  },
  pricing: {
    title: { ar: 'أسعار بسيطة وشفافة', en: 'Simple, Transparent Pricing' },
    subtitle: { ar: 'ابدأ صغيراً. وسع نطاق نموك. إلغاء في أي وقت.', en: 'Start small. Scale as you grow. Cancel anytime.' },
    starter: { ar: 'المبتدئ', en: 'Starter' },
    starterDesc: { ar: 'مثالي للفرق الصغيرة', en: 'Perfect for small teams' },
    professional: { ar: 'المحترف', en: 'Professional' },
    professionalDesc: { ar: 'الأفضل للمؤسسات المتنامية', en: 'Best for growing SMEs' },
    business: { ar: 'الأعمال', en: 'Business' },
    businessDesc: { ar: 'للمؤسسات الكبيرة', en: 'For larger organizations' },
    mostPopular: { ar: 'الأكثر شعبية', en: 'MOST POPULAR' },
    perMonth: { ar: 'د.ك/شهر', en: 'KWD/mo' },
    queries: { ar: 'استفسار/شهر', en: 'queries/month' },
    storage: { ar: 'مساحة تخزين', en: 'storage' },
    users: { ar: 'مستخدمين', en: 'users' },
    unlimitedUsers: { ar: 'مستخدمون غير محدودين', en: 'Unlimited users' },
    webWidget: { ar: 'أداة الويب', en: 'Web widget' },
    whatsappWeb: { ar: 'واتساب + ويب', en: 'WhatsApp + Web' },
    advancedAnalytics: { ar: 'تحليلات متقدمة', en: 'Advanced analytics' },
    prioritySupport: { ar: 'دعم ذو أولوية', en: 'Priority support' },
    startTrial: { ar: 'ابدأ التجربة المجانية', en: 'Start Free Trial' },
    setupFee: { ar: 'رسوم الإعداد:', en: 'Setup fee:' },
    waived: { ar: '(يتم التنازل عنها للعقود السنوية)', en: '(waived for annual contracts)' },
    trialInfo: { ar: 'جميع الخطط تشمل تجربة مجانية لمدة 14 يومًا • لا حاجة لبطاقة ائتمان • خصم 15٪ للدفع السنوي', en: 'All plans include 14-day free trial • No credit card required • 15% discount for annual payment' }
  },
  cta: {
    title: { ar: 'هل أنت مستعد لتحويل عملك؟', en: 'Ready to Transform Your Business?' },
    subtitle: { ar: 'انضم إلى المؤسسات التي توفر 40+ ساعة شهرياً. انشر في 24 ساعة.', en: 'Join SMEs saving 40+ hours monthly. Deploy in 24 hours.' },
    button: { ar: 'ابدأ تجربة مجانية لمدة 14 يومًا', en: 'Start Free 14-Day Trial' },
    info: { ar: 'لا حاجة لبطاقة ائتمان • الإعداد في 24 ساعة • إلغاء في أي وقت', en: 'No credit card required • Setup in 24 hours • Cancel anytime' }
  },
  footer: {
    tagline: { ar: 'مساعد المعرفة الذكي بالعربية أولاً للمؤسسات العربية الصغيرة والمتوسطة.', en: 'The Arabic-first AI knowledge assistant for Arabian SMEs.' },
    copyright: { ar: '. جميع الحقوق محفوظة.', en: '. All rights reserved.' },
    copyrightYear: { ar: `© ${new Date().getFullYear()} `, en: `© ${new Date().getFullYear()} ` }
  }
};

export default T;
